import { aspectRationImageFit, aspectRationImagePosition } from '@ag1/ui';
import { imageUrlBuilderFor } from '@portal/shared/utils/urlFor';
import { getExtension, SanityReference } from '@sanity/asset-utils';
import { FileExtension } from 'constants/file-extensions';
import client from 'sanity-client';
import { z } from 'zod';
import { omit } from '../../../shared/utils/omit';

const rawImage = z.object({
  _type: z.string(),
  asset: z.object({
    _type: z.string(),
    _ref: z.string()
  }),
  alt: z.string().optional().default(''),
  fit: aspectRationImageFit.optional(),
  position: aspectRationImagePosition.optional()
});

const rawImageOptional = z.object({
  _type: z.string(),
  asset: z
    .object({
      _type: z.string(),
      _ref: z.string()
    })
    .optional(),
  alt: z.string().optional().default(''),
  fit: aspectRationImageFit.optional(),
  position: aspectRationImagePosition.optional()
});

type RawImage = z.infer<typeof rawImage>;
type RawImageOptional = z.infer<typeof rawImageOptional>;

const urlFor = (source: RawImage | RawImageOptional) =>
  imageUrlBuilderFor(client).image(source).url();

function transform(source: RawImage | RawImageOptional) {
  return {
    ...omit(source, '_type', 'asset'),
    ext: getExtension(source.asset as SanityReference) as FileExtension,
    url: urlFor(source)
  };
}

export const sanityImage = rawImage.transform(transform);

export const sanityOptionalImage = rawImageOptional
  .transform((val) => (val?.asset ? transform(val) : null))
  .optional();

export type SanityImage = z.infer<typeof sanityImage>;
